import Image from 'app/Components/Shared/Image/image';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import BusinessPromoImageBlockData from 'app/Models/Content/BusinessPromoImageBlockData';
import React, {useState, useEffect, useRef, useCallback} from 'react';
import {isMobile} from 'react-device-detect';
import {useInView} from 'react-intersection-observer';
import {getImageProps} from 'app/utilities/ImageProps';

const BusinessPromoImageBlock = ({data, context}: ComponentProps<BusinessPromoImageBlockData>) => {
  const [offset, setOffset] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const {ref: inViewRef, inView} = useInView();

  const parallaxFactor = isMobile ? 0.5 : 0.5;

  useEffect(() => {
    function handleScroll() {
      if (inView) {
        const {offsetTop, clientHeight} = ref.current;
        setOffset(window.pageYOffset - offsetTop + clientHeight);
      }
    }

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [ref.current, inView]);

  const refCallback = useCallback((node: HTMLDivElement) => {
    inViewRef(node);
    ref.current = node;
  }, []);

  return (
    <div ref={refCallback} className='BusinessPromoImageBlock'>
      <div className='BusinessPromoImageBlock__image__wrap'>
        <Image className='BusinessPromoImageBlock__image__parallax'
          {...getImageProps(data.image, context)}
          style={{
            transform: `translate3d(0,${offset * parallaxFactor}px,0)`,
          }} />
      </div>
      <div className='BusinessPromoImageBlock__content'>
        <h3 className='BusinessPromoImageBlock__content__title'>{data.title.value}</h3>
        <p className='BusinessPromoImageBlock__content__description'>{data.description.value}</p>
        <div className='BusinessPromoImageBlock__content__link'>
          <a className='BusinessPromoImageBlock__content__link__button' href={data.buttonLink.value}>
            {data.buttonLinkTitle.value}
          </a>
        </div>
      </div>
    </div>
  );
};

export default BusinessPromoImageBlock;
